/*eslint no-unused-vars: ["error", { "args": "none" }]*/
import {
  Configuration,
  PrenotazioniApi,
} from "@/generated-sources/prenotazioni-api";
import { store } from "@/store/store";

const configuration = new Configuration({
  basePath: process.env.VUE_APP_API_ENDPOINT,
  accessToken: () => {
    // Lettura sincrona dallo store invece di dispatch asincrono
    const tokens = store.getters.getTokens as any;
    return tokens.accessToken;
  },
});
const prenotazioniApi = new PrenotazioniApi(configuration);

export async function subscribeToGameV2(
  bookingId: string,
  wesmashUserId: string,
  spot: number
) {
  try {
    return await prenotazioniApi.subscribe(bookingId, {
      wesmash_user_id: wesmashUserId,
      spot,
    });
  } catch (error) {
    throw error;
  }
}
export async function unsubscribeFromGameV2(
  bookingId: string,
  wesmashUserId: string
) {
  try {
    return await prenotazioniApi.unsubscribe(bookingId, {
      wesmash_user_id: wesmashUserId,
    });
  } catch (error) {
    throw error;
  }
}
export async function getBookingDetail(bookingId: string) {
  try {
    return await prenotazioniApi.getBookingDetail(bookingId);
  } catch (error) {
    throw error;
  }
}
